export { default as Img200 } from './processed/200/yes.jpg';
export { default as Img400 } from './processed/400/yes.jpg';
export { default as Img600 } from './processed/600/yes.jpg';
export { default as Imgthumb } from './processed/thumb/yes.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/yes.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/yes.jpg';
export const ImgData = { width: 1024, height: 768, ratio: 0.75, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      206,
      75,
      38
    ],
    "_population": 260,
    "_hsl": [
      0.03670634920634921,
      0.6885245901639344,
      0.47843137254901963
    ]
  },
  "LightVibrant": {
    "_rgb": [
      236,
      229,
      136
    ],
    "_population": 31,
    "_hsl": [
      0.155,
      0.7246376811594204,
      0.7294117647058824
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      84,
      44,
      30
    ],
    "_population": 18,
    "_hsl": [
      0.043209876543209874,
      0.4736842105263158,
      0.22352941176470587
    ]
  },
  "Muted": {
    "_rgb": [
      174,
      123,
      105
    ],
    "_population": 739,
    "_hsl": [
      0.04347826086956522,
      0.29870129870129875,
      0.5470588235294118
    ]
  },
  "LightMuted": {
    "_rgb": [
      172,
      164,
      212
    ],
    "_population": 1,
    "_hsl": [
      0.6944444444444445,
      0.35820895522388074,
      0.7372549019607844
    ]
  },
  "DarkMuted": {
    "_rgb": [
      102,
      68,
      53
    ],
    "_population": 2995,
    "_hsl": [
      0.051020408163265286,
      0.3161290322580645,
      0.303921568627451
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/yes.js